import { Card } from "@digdir/designsystemet-react";
import Markdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";
import { MarkdownCode } from "@/components/markdown/MarkdownCode";
import {
  MarkdownH1,
  MarkdownH2,
  MarkdownH3,
  MarkdownH4,
  MarkdownH5,
  MarkdownHr,
} from "@/components/markdown/MarkdownHeading";
import { MarkdownTh } from "@/components/markdown/MarkdownTh";

const components: Components = {
  h1: MarkdownH1,
  h2: MarkdownH2,
  h3: MarkdownH3,
  h4: MarkdownH4,
  h5: MarkdownH5,
  code: MarkdownCode,
  th: MarkdownTh,
  hr: MarkdownHr,
};

export const MarkdownFile = ({ markdown }: { markdown: string }) => {
  return (
    <Card
      variant="tinted"
      className="bg-balder-background-tinted p-6 my-6 w-fit"
    >
      <Markdown remarkPlugins={[remarkGfm]} components={components}>
        {markdown}
      </Markdown>
    </Card>
  );
};
